import * as React from "react";
const SvgFiRrMaskFace = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-mask-face_svg__a)">
      <path
        fill="#062147"
        d="M22.15.917a4.54 4.54 0 0 0-4.012-.735l-8.056 2.332c-.775.225-1.642.404-2.647.548-1.048.15-2.448.48-3.17 1.202-.58.58-.984 1.646-1.2 3.17a19.6 19.6 0 0 1-.549 2.647L.183 18.137a4.53 4.53 0 0 0 .735 4.012 4.53 4.53 0 0 0 3.65 1.822h6.403c.18 0 4.463-.049 8.707-4.293s4.293-8.526 4.293-8.707V4.567A4.53 4.53 0 0 0 22.15.917m-3.456 1.187q.358-.104.72-.104c.546 0 1.081.177 1.533.517a2.54 2.54 0 0 1 1.024 2.05v4.99l-6.515-6.516zM2.517 20.948a2.55 2.55 0 0 1-.413-2.254l.938-3.239 6.516 6.516h-4.99a2.55 2.55 0 0 1-2.05-1.023m15.747-2.684c-2.346 2.346-4.69 3.205-6.065 3.521l-8.522-8.524.76-2.623c.25-.866.448-1.82.606-2.92.161-1.126.442-1.846.636-2.04s.915-.476 2.04-.636a21.5 21.5 0 0 0 2.92-.606l2.625-.76 8.522 8.522c-.317 1.377-1.175 3.72-3.52 6.066zm-3.459-9.029L9.371 14.67a.997.997 0 0 1-1.414 0 1 1 0 0 1 0-1.414l5.434-5.434a.999.999 0 1 1 1.414 1.414m2.828 1.414a1 1 0 0 1 0 1.414L12.2 17.498a.997.997 0 0 1-1.414 0 1 1 0 0 1 0-1.414l5.434-5.435a1 1 0 0 1 1.414 0"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-mask-face_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrMaskFace;
